import { NavLink } from 'react-router-dom';
import './index.css';
import serviceIcon3dPrint from '../../assets/images/service-icon-3dprint.webp';
import serviceIconApps from '../../assets/images/service-icon-apps.webp';
import serviceIconConsulting from '../../assets/images/service-icon-consulting.webp';
import serviceIconWebsite from '../../assets/images/service-icon-website.webp';

const serviceLinks = [
  { title: 'Custom 3D Prints', path: '/services/3dprints', icon: serviceIcon3dPrint },
  { title: 'Websites', path: '/services/websites', icon: serviceIconWebsite },
  { title: 'App Development', path: '/services/appdev', icon: serviceIconApps },
  { title: 'Tech Consulting', path: '/services/consulting', icon: serviceIconConsulting },
];

const ServicesSubMenu = () => {
  return (
    <div className="services-submenu" role="navigation" aria-label="Service pages">
      {serviceLinks.map((service) => (
        <NavLink
          key={service.path}
          to={service.path}
          aria-label={service.title}
          title={service.title}
          className={({ isActive }) =>
            `services-submenu-link ${isActive ? 'active' : ''}`
          }
        >
          <img src={service.icon} alt="" aria-hidden="true" />
        </NavLink>
      ))}
    </div>
  );
};

export default ServicesSubMenu;
